import { Navigate, Outlet } from 'react-router-dom';

const isAuthenticated = () => {
  return localStorage.getItem('loginData') !== null;
};

const ProtectedLayout = () => {
  if (!isAuthenticated()) {
    // return <Navigate to="/login" replace />; // Redirect to /login instead of /
    return <Navigate to="/" replace />; // Redirect to /login instead of /
  }

  return <Outlet />;
};

export default ProtectedLayout;
